module.exports = __webpack_public_path__ + "static/img/genomics_clusters_1.0609597.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/datastories/genomics_clusters_1.png
// module id = 3Q5w
// module chunks = 6